import { useContext } from 'react'

import { AvatarFallbackColorsContext } from './AvatarFallbackColors'

export const useAvatarFallbackColors = (): boolean =>
  useContext(AvatarFallbackColorsContext)
